import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-branch-header',
  templateUrl: './branch-header.component.html',
  styleUrl: './branch-header.component.scss'
})
export class BranchHeaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  logoSrc = './assets/media/sidemenu/yusr-logo.png';
  currentLang = 'ar';

  constructor(private localizationService: LocalizationService) {}

  ngOnInit(): void {
    // الحصول على اللغة الحالية من localStorage
    const cachedLang = this.localizationService.getCachedLanguage();
    if (cachedLang) {
      this.currentLang = cachedLang.toLowerCase();
    }

    // الاستماع لتغييرات اللغة
    this.localizationService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(lang => {
        this.currentLang = lang?.toLowerCase() || 'ar';
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
